module.exports = __webpack_public_path__ + "img/class1.faef8ef1.png";